export default __webpack_public_path__ + "images/WinterInformationBackground.web.png";